// @mui
import { Theme } from "@mui/material/styles";
// theme
import { ColorSchema } from "../palette";
//
import { ErrorIcon, SuccessIcon, WarningIcon } from "./CustomIcons";

// ----------------------------------------------------------------------

export default function Alert(theme: Theme) {
  const isLight = theme.palette.mode === "light";

  const standardStyle = (color: ColorSchema) => ({
    color: theme.palette[color][isLight ? "dark" : "light"],
    backgroundColor: theme.palette[color][isLight ? "light" : "dark"],
    "& .MuiAlert-icon": {
      color: theme.palette[color][isLight ? "main" : "light"],
    },
  });

  const filledStyle = (color: ColorSchema) => ({
    color: theme.palette[color].contrastText,
  });

  const outlinedStyle = (color: ColorSchema) => ({
    color: theme.palette[color][isLight ? "dark" : "light"],
    border: `solid 1px ${theme.palette[color][isLight ? "light" : "dark"]}`,
    backgroundColor: theme.palette[color][isLight ? "light" : "dark"],
    "& .MuiAlert-icon": {
      color: theme.palette[color][isLight ? "main" : "light"],
    },
  });

  return {
    MuiAlert: {
      defaultProps: {
        iconMapping: {
          success: <SuccessIcon />,
          warning: <WarningIcon />,
          error: <ErrorIcon />,
        },
      },

      styleOverrides: {
        message: {
          "& .MuiAlertTitle-root": {
            marginBottom: theme.spacing(0.5),
          },
        },
        action: {
          "& button:not(:first-of-type)": {
            marginLeft: theme.spacing(1),
          },
        },
        
        // Replace all composed CSS classes with atomic variants
        // eslint-disable-next-line no-empty-pattern
        root: ({}: { ownerState: { variant: string; color: string } }) => ({
          variants: [{
            props: {
              color: 'success',
              variant: 'standard'
            },
            style: standardStyle('success')
          }, {
            props: {
              color: 'warning',
              variant: 'standard'
            },
            style: standardStyle('warning')
          }, {
            props: {
              color: 'error',
              variant: 'standard'
            },
            style: standardStyle('error')
          }, {
            props: {
              color: 'success',
              variant: 'filled'
            },
            style: filledStyle('success')
          }, {
            props: {
              color: 'warning',
              variant: 'filled'
            },
            style: filledStyle('warning')
          }, {
            props: {
              color: 'error',
              variant: 'filled'
            },
            style: filledStyle('error')
          }, {
            props: {
              color: 'success',
              variant: 'outlined'
            },
            style: outlinedStyle('success')
          }, {
            props: {
              color: 'warning',
              variant: 'outlined'
            },
            style: outlinedStyle('warning')
          }, {
            props: {
              color: 'error',
              variant: 'outlined'
            },
            style: outlinedStyle('error')
          }]
        }),
      },
    },
  };
}
